{
  "Clear search": "Keresés törlése"
}
